import clsx from 'clsx';

import styles from './horizontal-separator.module.scss';

export interface Props {
  className?: string;
}

export function HorizontalSeparator({ className }: Props) {
  return <hr className={clsx(styles['page-separator'], className)} />;
}
